import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Product from "./pages/product";

export default function Routing() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Product />} />
      </Routes>
    </Router>
  );
}
